<template>
    <div class="">
        <div class="top_title">
            <div class="top_back_home" @click="backToindex">
                <img src="../../../public/images/home.png" alt=""/>
                <p>返回首页</p>
            </div>
            <div class="title">
                快速记账
            </div>
        </div>
        <div class="main">
            <div class="message">
                <div class="top">
                    <div class="left">
                        记账信息
                    </div>
                    <div class="right" @click="salesPerson">
                        <img src="../../../public/images/set.png" alt=""/>
                        <p>销售员信息</p>
                    </div>
                </div>
                <div class="middle">
                    <div class="tt">
                        批次<span>*</span>
                    </div>
                    <div class="select">
                        <el-select v-model="batch_id" placeholder="请选择">
                            <el-option v-for="item in batchList" :key="item.id" :label="item.batch_name"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="bottom">
                    <div class="item">
                        <div class="tt">
                            销售员<span>*</span>
                        </div>
                        <div class="select">
                            <el-select v-model="sale_id" placeholder="请选择" @change="changeSaleSelect">
                                <el-option v-for="item in tableDataSalesPerson" :key="item.id" :label="item.name"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="item">
                        <div class="tt">
                            记账日期<span>*</span>
                        </div>
                        <div class="select">
                            <el-date-picker v-model="order_time" @change="changeJiZhangDate" type="date"
                                            format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期">
                            </el-date-picker>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 记账内容 -->
            <div class="content">
                <div class="top">
                    <div class="left">
                        记账内容
                    </div>
                    <div class="right">
                        <div class="itt" @click="addCustomer(1)">
                            <img src="../../../public/images/add.png" alt=""/>
                            <p>添加客户</p>
                        </div>
                        <div class="itt" @click="shopManagement">
                            <img src="../../../public/images/set.png" alt=""/>
                            <p>商品管理</p>
                        </div>
                    </div>
                </div>
                <div class="table">
                    <el-table :data="orderDetail" style="width: 100%">
                        <el-table-column label="日期">
                            <template slot-scope="scope">
                                <el-date-picker size="small" v-model="scope.row.time" type="date" placeholder="选择日期"
                                                format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 140px">
                                </el-date-picker>
                            </template>
                        </el-table-column>

                        <el-table-column label="客户">
                            <template slot-scope="scope">
                                <el-select size="small" @change="changeSelectCustomer(scope.$index)"
                                           v-model="scope.row.customer_id" placeholder="请选择客户"
                                           :class="scope.row.isWarning ? 'same' : ''">
                                    <el-option v-for="item in tableDataAddCustomer" :key="item.id" :label="item.name"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>

                        <el-table-column label="商品">
                            <template slot-scope="scope">
                                <el-select size="small" @change="changeSelectProduct(scope.$index)"
                                           v-model="scope.row.product_id" placeholder="请选择商品">
                                    <el-option v-for="item in tableDataShopManagement" :key="item.id" :label="item.name"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>

                        <el-table-column label="数量">
                            <template slot-scope="scope">
                                <el-input
                                    type="number"
                                    size="small" v-model="scope.row.number" :min="0" :step="1"
                                    @input="calculateLineNumberChange(scope.$index)" controls-position="right">
                                </el-input>
                            </template>
                        </el-table-column>

                        <el-table-column label="单价">
                            <template slot-scope="scope">
                                <el-input type="number" size="small" clearable v-model="scope.row.price" :min="0" placeholder="请输入单价"
                                                 @input="calculateLine(scope.$index)" controls-position="right">
                                </el-input>
                            </template>
                        </el-table-column>

                        <el-table-column label="总金额">
                            <template slot-scope="scope">
                                <el-input size="small" v-model.number="scope.row.total_fee" readonly></el-input>
                            </template>
                        </el-table-column>

                        <el-table-column fixed="right" label="操作" width="80">
                            <template slot-scope="scope">
                                <el-button @click="deleteMainRow(scope.$index)" type="text" size="small">
                                    <img src="../../../public/images/del.png" alt=""/>
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <div class="actions">
                        <el-button @click="addMainRow">+ 新增</el-button>
                    </div>
                    <div class="submit">
                        <el-button @click="submitForm">保存记账</el-button>
                    </div>
                </div>
            </div>

            <!-- 销售员管理弹窗 -->
            <div v-if="showDialogSalesPerson" class="dialog-overlay">
                <div class="dialog-content">
                    <div class="dialog-header">
                        销售员管理
                        <img @click="closeDialogSalesPerson" src="../../../public/images/close.png" alt=""/>
                    </div>
                    <div class="dialog-body">
                        <div class="table">
                            <el-table :data="tableDataSalesPerson" height="300">
                                <el-table-column prop="name" label="姓名">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.name" placeholder="请输入姓名"></el-input>
                                    </template>
                                </el-table-column>

                                <el-table-column prop="phone" label="电话">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.phone" placeholder="请输入电话"></el-input>
                                    </template>
                                </el-table-column>

                                <el-table-column label="操作" width="50">
                                    <template slot-scope="scope">
                                        <el-button @click="deleteSalesPersonRow(scope.$index)" type="text" size="small">
                                            <img src="../../../public/images/del.png" alt=""/>
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>

                            <div class="actions">
                                <el-button @click="addSalesPersonRow">+ 新增</el-button>
                            </div>
                            <div class="submit">
                                <el-button @click="submitSalesPersonForm">确认</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 添加客户弹窗 -->
            <div v-if="showDialogAddCustomer" class="dialog-overlay">
                <div class="dialog-content">
                    <div class="dialog-header">
                        添加客户
                        <img @click="closeDialogAddCustomer" src="../../../public/images/close.png" alt=""/>
                    </div>
                    <div class="dialog-body">
                        <div class="table">
                            <el-table :data="tableDataAddCustomer" style="width: 100%" height="300">
                                <el-table-column prop="name" label="姓名" width="200">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.name" placeholder="请输入姓名"></el-input>
                                    </template>
                                </el-table-column>

                                <el-table-column prop="phone" label="电话" width="200">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.phone" placeholder="请输入电话"></el-input>
                                    </template>
                                </el-table-column>

                                <el-table-column label="备注">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.remark" placeholder="请输入"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column fixed="right" label="操作" width="50">
                                    <template slot-scope="scope">
                                        <el-button @click="deleteAddCustomerRow(scope.$index)" type="text" size="small">
                                            <img src="../../../public/images/del.png" alt=""/>
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>

                            <div class="actions">
                                <el-button @click="addAddCustomerRow">+ 新增</el-button>
                            </div>
                            <div class="submit">
                                <el-button @click="submitAddCustomerForm">确认</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 商品管理弹窗 -->
            <div v-if="showDialogShopManagement" class="dialog-overlay">
                <div class="dialog-content">
                    <div class="dialog-header">
                        商品管理
                        <img @click="closeDialogShopManagement" src="../../../public/images/close.png" alt=""/>
                    </div>
                    <div class="dialog-body">
                        <div class="table">
                            <el-table :data="tableDataShopManagement" style="width: 100%" height="300">
                                <el-table-column prop="name" label="商品名称" width="200">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.name" placeholder="请输入商品名称"></el-input>
                                    </template>
                                </el-table-column>

                                <el-table-column prop="unit" label="单位" width="150">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.unit" placeholder="请输入单位"></el-input>
                                    </template>
                                </el-table-column>

                                <el-table-column prop="price" label="默认价格" width="150">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.price" placeholder="请输入价格"></el-input>
                                    </template>
                                </el-table-column>

                                <el-table-column prop="sort" label="排序" width="100">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.sort" type="number" placeholder="请输入"></el-input>
                                    </template>
                                </el-table-column>

                                <el-table-column label="是否羊下水" width="200">
                                    <template slot-scope="scope">
                                        <el-radio-group v-model="scope.row.is_offal">
                                            <el-radio :label="1">否</el-radio>
                                            <el-radio :label="2">是</el-radio>
                                        </el-radio-group>
                                    </template>
                                </el-table-column>

                                <el-table-column label="操作" width="50">
                                    <template slot-scope="scope">
                                        <el-button @click="deleteShopManagementRow(scope.$index)" type="text"
                                                   size="small">
                                            <img src="../../../public/images/del.png" alt=""/>
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="actions">
                                <el-button @click="addShopManagementRow">+ 新增</el-button>
                            </div>
                            <div class="submit">
                                <el-button @click="submitShopManagementForm">确认</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    data() {
        return {
            batchList: [],
            batch_id: 0,
            sale_id: 0,
            order_time: '',

            //表格
            orderDetail: [{
                time: '',
                customer_id: '',
                product_id: '',
                product_name: '',
                is_offal: 1,
                number: '',
                price: '',
                total_fee: 0,
                isWarning: false,
            }],

            //销售员管理
            showDialogSalesPerson: false,
            tableDataSalesPerson: [{
                name: '',
                phone: ''
            }],
            //添加客户
            showDialogAddCustomer: false,
            tableDataAddCustomer: [{
                name: '',
                phone: '',
                word: '',
            }],
            //商品管理
            showDialogShopManagement: false,
            tableDataShopManagement: [{
                id: 0,
                name: '',
                unit: '',
                price: '',
                is_offal: 1,
                sort: 50,
            }],
            //温馨提示弹窗
            dialogVisible: false
        }
    },
    mounted() {
        // 获取批次
        this.order_time = this.getCurrentDate();
        this.getSelectData();
    },
    computed: {
        totalAmount() {
            return this.tableData.reduce((sum, row) => sum + (parseFloat(row.totalAmount) || 0), 0).toFixed(2);
        }
    },
    methods: {
        //返回首页
        backToindex() {
            this.$router.push({
                path: '/',
            })
        },
        getCurrentDate() {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0'); // 月份是从0开始的
            const day = String(today.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        changeJiZhangDate() {
            for (var i = 0; i < this.orderDetail.length; i++) {
                this.orderDetail[i].time = this.order_time;
            }
        },

        getSelectData() {
            const loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.get('/quick/getSelectData').then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.batchList = res.data.data.batchList;
                    if (res.data.data.batchList.length > 0) {
                        this.batch_id = res.data.data.batchList[0].id;
                    }
                    this.tableDataSalesPerson = res.data.data.saleList;
                    if (res.data.data.saleList.length > 0) {
                        this.sale_id = res.data.data.saleList[0].id;
                    }
                    // 产品
                    this.tableDataShopManagement = res.data.data.productList;

                    this.order_time = this.getCurrentDate();
                    this.addCustomer(0);

                    // 初始化订单详情
                    this.orderDetail = [{
                        time: this.getCurrentDate(),
                        customer_id: '',
                        product_id: this.tableDataShopManagement.length > 0 ? this.tableDataShopManagement[0].id : '',
                        product_name: this.tableDataShopManagement.length > 0 ? this.tableDataShopManagement[0].name : '',
                        is_offal: 1,
                        number: '',
                        price: this.tableDataShopManagement.length > 0 ? this.tableDataShopManagement[0].price : '',
                        total_fee: 0,
                        isWarning: false,
                    }];
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },
        // 切换选择客户
        changeSelectCustomer(index) {
            var customerIdArr = [];
            for (var i = 0; i < this.orderDetail.length; i++) {
                customerIdArr.push(this.orderDetail[i].customer_id);
                this.orderDetail[i].isWarning = false;
            }
            for (var j = 0; j < customerIdArr.length; j++) {
                if (customerIdArr[j] > 0) {
                    var count = customerIdArr.reduce((total, current) => {
                        return current === customerIdArr[j] ? total + 1 : total;
                    }, 0);
                    if (count > 1) {
                        for (var k = 0; k < customerIdArr.length; k++) {
                            if (customerIdArr[j] == customerIdArr[k]) {
                                this.orderDetail[k].isWarning = true;
                            }
                        }
                    }
                }
            }
        },
        // 切换选择商品
        changeSelectProduct(index) {
            // 选出商品
            for (var i = 0; i < this.tableDataShopManagement.length; i++) {
                if (this.orderDetail[index].product_id == this.tableDataShopManagement[i].id) {
                    this.orderDetail[index].product_name = this.tableDataShopManagement[i].name;
                    this.orderDetail[index].is_offal = this.tableDataShopManagement[i].is_offal;
                    this.orderDetail[index].price = this.tableDataShopManagement[i].price;
                }
            }
            // 计算单行总金额
            this.calculateLine(index);
        },
        // 计算单行总金额
        calculateLine(index) {
            this.orderDetail[index].total_fee = parseInt((+this.orderDetail[index].number) * (+this.orderDetail[index].price), 10);
        },
        // 自动加一行
        calculateLineNumberChange(index){
            var length = this.orderDetail.length;
            if((+this.orderDetail[length - 1].number) > 0){
                this.addMainRow();
            }
            this.calculateLine(index);
        },

        deleteMainRow(index) {
            if (this.orderDetail.length > 1) {
                this.orderDetail.splice(index, 1);
            } else {
                this.$message.warning('至少保留一行数据');
            }
        },
        addMainRow() {
            this.orderDetail.push({
                time: this.order_time,
                customer_id: '',
                product_id: this.tableDataShopManagement.length > 0 ? this.tableDataShopManagement[0].id : '',
                product_name: this.tableDataShopManagement.length > 0 ? this.tableDataShopManagement[0].name : '',
                is_offal: 1,
                number: '',
                price: this.tableDataShopManagement.length > 0 ? this.tableDataShopManagement[0].price : '',
                total_fee: 0,
                isWarning: false,
            });
        },
        submitForm() {

            // 过滤掉信息不完整的行
            const validRows = this.orderDetail.filter(row =>
                row.customer_id > 0 && row.product_id > 0 && row.number > 0
            );
            if (validRows.length === 0) {
                this.$message.error('请填写完整的记账内容');
                return;
            }

            const loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.post('/order/editOrder', {
                batch_id: this.batch_id,
                sale_id: this.sale_id,
                order_time: this.order_time,
                orderDetail: validRows,
            }).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.$message({
                        message: "提交成功！",
                        type: "success",
                    });
                    this.backToindex();
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },

        // 销售员管理弹窗
        changeSaleSelect() {
            this.addCustomer(0);
        },
        salesPerson() {
            const loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.get('/sale/getSaleList').then(res => {
                loading.close();
                if (res.data.code == 0) {
                    if (res.data.data.length > 0) {
                        this.tableDataSalesPerson = res.data.data;
                    } else {
                        this.tableDataSalesPerson = [{
                            id: 0,
                            name: '',
                            phone: '',
                        }];
                    }
                    this.showDialogSalesPerson = true;
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });

        },
        closeDialogSalesPerson() {
            this.showDialogSalesPerson = false;
        },
        // 销售员表格相关方法
        deleteSalesPersonRow(index) {
            if (this.tableDataSalesPerson.length > 1) {
                if (this.tableDataSalesPerson[index].id <= 0) {
                    var newTableDataSalesPerson = [];
                    for (var i = 0; i < this.tableDataSalesPerson.length; i++) {
                        if (i != index) {
                            newTableDataSalesPerson.push(this.tableDataSalesPerson[i]);
                        }
                    }
                    this.tableDataSalesPerson = newTableDataSalesPerson;
                    return false;
                }
                this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    const loading = this.$loading({
                        lock: true,
                        text: '',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    this.$http.post('/sale/delete', {
                        id: this.tableDataSalesPerson[index].id,
                    }).then(res => {
                        loading.close();
                        if (res.data.code == 0) {
                            this.$message({
                                message: "操作成功",
                                type: "success",
                            });
                            var newTableDataSalesPerson = [];
                            for (var i = 0; i < this.tableDataSalesPerson.length; i++) {
                                if (i != index) {
                                    newTableDataSalesPerson.push(this.tableDataSalesPerson[i]);
                                }
                            }
                            this.tableDataSalesPerson = newTableDataSalesPerson;
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.msg
                            })
                        }
                    });
                }).catch(() => {

                });
            } else {
                this.$message.warning('至少保留一行数据');
            }
        },
        addSalesPersonRow() {
            this.tableDataSalesPerson.push({
                id: 0,
                name: '',
                phone: ''
            });
        },
        submitSalesPersonForm() {
            // 过滤掉信息不完整的行
            const validRows = this.tableDataSalesPerson.filter(row =>
                row.name.trim() !== ''
            );

            if (validRows.length === 0) {
                this.$message.error('请填写销售员姓名');
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.post('/sale/editSale', {data: validRows}).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.$message({
                        message: "操作成功",
                        type: "success",
                    });
                    // this.$message.success('销售员信息保存成功！');
                    // this.productManagement();
                    this.closeDialogSalesPerson();
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },
        // 添加客户弹窗
        addCustomer(isShow = 1) {
            if (this.sale_id <= 0) {
                this.$message({
                    type: '请先选择销售员',
                    message: res.data.msg
                })
                return false;
            }
            var loading;
            if (isShow == 1) {
                loading = this.$loading({
                    lock: true,
                    text: '',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
            }
            this.$http.get('/customer/getCustomerList?sale_id=' + this.sale_id).then(res => {
                if (isShow == 1) {
                    loading.close();
                }
                if (res.data.code == 0) {
                    if (res.data.data.length > 0) {
                        this.tableDataAddCustomer = res.data.data;
                    } else {
                        this.tableDataAddCustomer = [{
                            id: 0,
                            sale_id: this.sale_id,
                            name: '',
                            phone: '',
                            remark: '',
                        }];
                    }
                    if (isShow == 1) {
                        this.showDialogAddCustomer = true;
                    }
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },
        closeDialogAddCustomer() {
            this.showDialogAddCustomer = false;
        },
        addAddCustomerRow() {
            this.tableDataAddCustomer.push({
                id: 0,
                sale_id: this.sale_id,
                name: '',
                phone: '',
                remark: ''
            });
        },
        deleteAddCustomerRow(index) {
            if (this.tableDataAddCustomer.length > 1) {
                if (this.tableDataAddCustomer[index].id <= 0) {
                    var newTableDataCustomer = [];
                    for (var i = 0; i < this.tableDataAddCustomer.length; i++) {
                        if (i != index) {
                            newTableDataCustomer.push(this.tableDataAddCustomer[i]);
                        }
                    }
                    this.tableDataAddCustomer = newTableDataCustomer;
                    return false;
                }
                this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    const loading = this.$loading({
                        lock: true,
                        text: '',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    this.$http.post('/customer/delete', {
                        id: this.tableDataAddCustomer[index].id,
                    }).then(res => {
                        loading.close();
                        if (res.data.code == 0) {
                            this.$message({
                                message: "操作成功",
                                type: "success",
                            });
                            var newTableDataCustomer = [];
                            for (var i = 0; i < this.tableDataAddCustomer.length; i++) {
                                if (i != index) {
                                    newTableDataCustomer.push(this.tableDataAddCustomer[i]);
                                }
                            }
                            this.tableDataAddCustomer = newTableDataCustomer;
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.msg
                            })
                        }
                    });
                }).catch(() => {

                });
            } else {
                this.$message.warning('至少保留一行数据');
            }
        },
        submitAddCustomerForm() {
            // 过滤掉信息不完整的行
            const validRows = this.tableDataAddCustomer.filter(row =>
                row.name.trim() !== ''
            );

            if (validRows.length === 0) {
                this.$message.error('请填写完整的客户信息');
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.post('/customer/editCustomer', {data: validRows}).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.$message({
                        message: "客户信息保存成功！",
                        type: "success",
                    });
                    // this.$message.success('销售员信息保存成功！');
                    // this.productManagement();
                    this.closeDialogAddCustomer();
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },
        // 商品管理弹窗
        shopManagement() {
            var loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.get('/product/getProductList').then(res => {
                loading.close();
                if (res.data.code == 0) {
                    if (res.data.data.length > 0) {
                        this.tableDataShopManagement = res.data.data;
                    } else {
                        this.tableDataShopManagement = [{
                            id: 0,
                            name: '',
                            unit: '',
                            price: '',
                            is_offal: 1,
                            sort: 50,
                        }];
                    }
                    this.showDialogShopManagement = true;
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },
        closeDialogShopManagement() {
            this.showDialogShopManagement = false;
        },
        addShopManagementRow() {
            this.tableDataShopManagement.push({
                id: 0,
                name: '',
                unit: '',
                price: '',
                is_offal: 1,
                sort: 50,
            });
        },
        deleteShopManagementRow(index) {
            if (this.tableDataShopManagement.length > 1) {
                if (this.tableDataShopManagement[index].id <= 0) {
                    var newTableDataShopManagement = [];
                    for (var i = 0; i < this.tableDataShopManagement.length; i++) {
                        if (i != index) {
                            newTableDataShopManagement.push(this.tableDataShopManagement[i]);
                        }
                    }
                    this.tableDataShopManagement = newTableDataShopManagement;
                    return false;
                }
                this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    const loading = this.$loading({
                        lock: true,
                        text: '',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    this.$http.post('/product/delete', {
                        id: this.tableDataShopManagement[index].id,
                    }).then(res => {
                        loading.close();
                        if (res.data.code == 0) {
                            this.$message({
                                message: "操作成功",
                                type: "success",
                            });
                            var newTableDataShopManagement = [];
                            for (var i = 0; i < this.tableDataShopManagement.length; i++) {
                                if (i != index) {
                                    newTableDataShopManagement.push(this.tableDataShopManagement[i]);
                                }
                            }
                            this.tableDataShopManagement = newTableDataShopManagement;
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.msg
                            })
                        }
                    });
                }).catch(() => {

                });
            } else {
                this.$message.warning('至少保留一行数据');
            }
        },
        submitShopManagementForm() {
            // 过滤掉信息不完整的行
            const validRows = this.tableDataShopManagement.filter(row =>
                row.name.trim() !== ''
            );

            if (validRows.length === 0) {
                this.$message.error('请填写完整的商品信息');
                return;
            }

            const loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.post('/product/editProduct', {data: validRows}).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.$message({
                        message: "商品信息保存成功！",
                        type: "success",
                    });
                    // this.$message.success('销售员信息保存成功！');
                    // this.productManagement();
                    this.closeDialogShopManagement();
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },
        handleClose(done) {
            done();
        }
    }
}
</script>

<style lang="less" scoped>
.main {
    padding: 0 20px;
    box-sizing: border-box;
    margin-top: 37px;
    padding-bottom: 100px;

    .top_title {
        position: fixed;
        left: 0;
        top: 10px;
        z-index: 2;
        width: 100%;

        .top_fixed {
            position: fixed;
            left: 3px;
            top: 10px;
            display: flex;
            align-items: center;

            img {
                display: block;
                width: 20px;
                height: 20px;
                margin-right: 3px;
            }

            p {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 16px;
                color: #FFFFFF;
            }
        }

        .title {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 18px;
            color: #FFFFFF;
            line-height: 28px;
            text-align: center;
        }
    }

    .message {
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        padding: 20px;
        margin-bottom: 20px;

        .top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 6px 0;

            .left {
                padding-left: 8px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 18px;
                color: #36363A;
                line-height: 28px;
                position: relative;
            }

            .left::after {
                content: '';
                display: block;
                width: 4px;
                height: 17px;
                background: #3F72FF;
                border-radius: 12px 12px 12px 12px;
                position: absolute;
                left: 0;
                top: 6px;
            }

            .right {
                display: flex;
                align-items: center;
                cursor: pointer;

                img {
                    display: block;
                    width: 16px;
                    height: 16px;
                    margin-right: 4px;
                }

                p {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #3F72FF;
                }
            }
        }

        .middle {
            .tt {
                display: flex;
                margin-top: 12px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #36363A;

                span {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #CB2D18;
                }
            }

            .select {
                margin-top: 12px;
                width: 100%;

                .el-select {
                    width: 100%;
                }
            }
        }

        .bottom {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .item {
                flex: 0 0 48%;

                .tt {
                    display: flex;
                    margin-top: 12px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #36363A;

                    span {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                        color: #CB2D18;
                    }
                }

                .select {
                    margin-top: 12px;
                    width: 100%;

                    .el-select {
                        width: 100%;
                    }

                    .el-date-editor.el-input,
                    .el-date-editor.el-input__inner {
                        width: 100%;
                    }
                }
            }
        }
    }

    .content {
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        padding: 20px;
        margin-bottom: 20px;

        .top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 6px 0;

            .left {
                padding-left: 8px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 18px;
                color: #36363A;
                line-height: 28px;
                position: relative;
            }

            .left::after {
                content: '';
                display: block;
                width: 4px;
                height: 17px;
                background: #3F72FF;
                border-radius: 12px 12px 12px 12px;
                position: absolute;
                left: 0;
                top: 6px;
            }

            .right {
                display: flex;
                align-items: center;

                .itt {
                    display: flex;
                    align-items: center;
                    cursor: pointer;

                    img {
                        display: block;
                        width: 16px;
                        height: 16px;
                        margin-right: 4px;
                    }

                    p {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                        color: #3F72FF;
                    }
                }

                .itt:first-child {
                    margin-right: 20px;
                }
            }
        }

        .table {
            .same {
                border: 1px solid red;
            }

            .el-table tr {
                background: #F5F6FC !important;
            }

            .el-button {
                img {
                    display: block;
                    width: 16px;
                    height: 16px;
                }
            }

            .actions {
                width: 100%;
                border-radius: 4px 4px 4px 4px;
                border: 1px dashed #C1D0FB;
                text-align: center;
                margin-top: 8px;

                .el-button {
                    margin: 0 auto;
                    border: 0;
                    padding: 0;
                    line-height: 40px;
                    height: 40px;
                    width: 100%;
                    display: block;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #3F72FF;
                }
            }

            .submit {
                position: fixed;
                bottom: 36px;
                left: 50%;
                z-index: 3;
                transform: translate(-50%, 0);
                width: 30%;
                border-radius: 60px;
                line-height: 60px;
                text-align: center;

                .el-button {
                    background: #3F72FF;
                    margin: 0 auto;
                    border: 0;
                    padding: 0;
                    line-height: 60px;
                    height: 60px;
                    border-radius: 60px;
                    width: 100%;
                    display: block;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 18px;
                    color: #FFFFFF;
                }
            }
        }
    }

    .dialog-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2000;

        .dialog-content {
            background: white;
            border-radius: 8px;
            width: 80%;
            max-width: 90%;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
            padding: 24px;

            .dialog-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 18px;
                color: #4A5676;
                margin-bottom: 26px;

                img {
                    display: block;
                    width: 24px;
                    height: 24px;
                    cursor: pointer;
                }
            }

            .dialog-body {
                .table {
                    .el-table tr {
                        background: #F5F6FC !important;
                    }

                    .el-button {
                        img {
                            display: block;
                            width: 16px;
                            height: 16px;
                        }
                    }

                    .actions {
                        width: 100%;
                        border-radius: 4px 4px 4px 4px;
                        border: 1px dashed #C1D0FB;
                        text-align: center;
                        margin-top: 8px;

                        .el-button {
                            margin: 0 auto;
                            border: 0;
                            padding: 0;
                            line-height: 40px;
                            height: 40px;
                            width: 100%;
                            display: block;
                            font-family: PingFang SC, PingFang SC;
                            font-weight: 400;
                            font-size: 16px;
                            color: #3F72FF;
                        }
                    }

                    .submit {
                        margin-top: 30px;
                        width: 100%;
                        border-radius: 60px;
                        line-height: 60px;
                        text-align: center;

                        .el-button {
                            background: #3F72FF;
                            margin: 0 auto;
                            border: 0;
                            padding: 0;
                            line-height: 60px;
                            height: 60px;
                            border-radius: 60px;
                            width: 100%;
                            display: block;
                            font-family: PingFang SC, PingFang SC;
                            font-weight: 500;
                            font-size: 18px;
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }
    }
}
</style>
